export const APP_VERSION = 'dev';
